import { z } from 'zod';

export const TransitUploadHouseItemsDataSchema = z.object({
  file: z.any().optional(), // File object from express-fileupload
});
export type TransitUploadHouseItemsData = z.infer<typeof TransitUploadHouseItemsDataSchema>;

export const TransitUploadDownloadHouseItemsDataSchema = TransitUploadHouseItemsDataSchema.merge(
  z.object({
    transitId: z.string().min(1, { message: 'Required' }),
    houseConsignmentIndex: z.union([z.number(), z.string()]),
    transitName: z.string().optional(),
  }),
);
export type TransitUploadDownloadHouseItemsData = z.infer<typeof TransitUploadDownloadHouseItemsDataSchema>;
